export default __webpack_public_path__ + "static/makula-vitamine-nahrstoffe-mineralien-nahrungserganzung-cfb4e902e8b03209bc71c472e52261ac.jpg";